import React from "react";
import { MOCK_PRODUCTS } from "../data/products";
import { ProductCard } from "../components/ProductCard";
import { PageTitle, ProductGrid } from "../components/styled";

export const HomePage: React.FC = () => {
  return (
    <>
      <PageTitle>Welcome to ShopDemo</PageTitle>
      <p
        style={{
          textAlign: "center",
          fontSize: "1.2rem",
          color: "#666",
          marginBottom: "2rem",
        }}
      >
        Discover our amazing collection of products
      </p>
      <ProductGrid>
        {MOCK_PRODUCTS.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </ProductGrid>
    </>
  );
};
